module.exports = __webpack_public_path__ + "static/media/Gant_logo.a7d868ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/pdf/templates/vlp/images/Gant_logo.png
// module id = 283
// module chunks = 10